<div class="w-full flex flex-col rounded-md shadow bg-slate-100 text-md">
    <div class="bg-ponder-light text-slate-50 p-2 rounded-t-md shadow-sm text-md flex flex-row gap-4">
        <div class="flex flex-col grow">
            <div>Card Details</div>
            <div class="text-sm text-faded-70">{{ getTreatmentList() }}</div>
        </div>
        <div class="flex flex-row gap-4">
            @if (hasNormalPrice()) { 
                <div>
                    {{ this.collectedMagicCard!.price.normalUSD | currency }}
                </div> 
            }
            @if (hasSpecialPrice()) { 
                <div class="text-foil">
                    {{ this.collectedMagicCard!.price.specialUSD | currency }}
                </div> 
            }
        </div>
    </div>
    <div class="flex flex-col gap-2 p-2">
        <!-- Tags -->
        <div class="border-b text-sm font-bold">
            Tags
        </div>
        <div class="flex items-center align-middle justify-center text-sm text-center text-slate-400 min-h-12 bg-slate-50 p-2 shadow-sm">
            None
        </div>
        <!-- Links -->
        <div class="border-b text-sm font-bold">
            Links
        </div>
        <magic-card-links [username]="username" [magicCard]="collectedMagicCard.card"></magic-card-links>
        <!-- Legality -->
        <div class="border-b text-sm font-bold">
            Legality
        </div>
        <magic-card-legality [legalityMask]="collectedMagicCard.card.legality"></magic-card-legality>
        <!-- Rulings -->
        <div class="border-b text-sm font-bold">
            Rulings
        </div>
        <magic-card-rulings [oracleId]="collectedMagicCard.card.oracleId!"></magic-card-rulings>
    </div>
</div>